import { Component, OnInit, Output, ViewEncapsulation, EventEmitter, ViewChild, HostListener } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { config } from '../../../../config/config';
import { HubFacebookFeedsCommand } from '../../../commands/hub/event/add.facebook.general.feed.command';
import { CustomDefaultPlaceCategory, HubCalendarActionCommand } from '../../../commands/pagination.query.command';
import { AccordionComponent } from '../../../common/components/accordion/accordion.component';
import { BaseComponent } from '../../../common/components/base.component';
import { ImageService } from '../../../services/image.service';
import { PlaceService } from '../../../services/place.service';
import { VisitorDataCache, VisitorSettingsStore } from '../../../stores/visitor.calendar.store';
import { LogoCommand, PDFSettingCommand } from '../export.pdf.modal/export.pdf.modal.provider';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { HubVisitorFeatureToggle, HubVisitorToggleDataSource } from '../../../models/hub/hub.visitor.feature.toggle';
import { CustomizationApiService } from '../../../services/customization.api.service';
import {
  CustomBtnStore,
  CustomDefaultPlaceCategoryStore,
  EditorChoiceStore,
  HubCalendarStore,
  HubFacebookLocationFeedsStore,
  HubFacebookPageFeedsStore,
  HubLogoStore,
  PDFSettingsStore,
  ToggleAndDataSourceStore,
  ToggleStore,
  ToursStore,
} from '../../../stores/hub.calendar.store';
import { HubApiService } from '../../../services/hub.api.service';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { PlaceType } from '../place.category/customize.place.category.component';
import { clone, isEmptyObject, isEmptyValue } from '../../../common/extensions';
import { EditorChoiceDataSource } from '../../../models/hub/hub.event';
import { EventTimeService } from '../../../services/event.time.service';
import { MatCheckbox } from '@angular/material/checkbox';
import { CustomDefaultPlaceCategoryAccordionComponent } from '../custom.default.place.category.accordion/custom.default.place.category.accordion.component.';
import { KeywordService } from '../../../services/keyword.service';

@Component({
  selector: 'ig-hub-side-bar',
  templateUrl: './hub.side.bar.component.html',
  styleUrls: ['./hub.side.bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HubNavigatorComponent extends BaseComponent implements OnInit {
  public hubName: string;
  public hubPages: Array<any>;
  public eventFeeds: Array<any>;
  public hubLocations: Array<any>;
  public facebookLocations: Array<any>;
  public otherLocations: Array<any>;
  public isFilterDateEnabled = false;
  public isLoadingFeeds = false;
  public eventStatusSelection = 'approved';
  public displayingOn = DisplayingOn.event;
  public searchFormGroup: FormGroup;
  public command = new HubCalendarActionCommand();
  public today = new Date();
  public logoUrl = config.defaultLogoUrl;
  public logo = {
    isDefault: true,
    url: '',
  };
  public toggleAndSource = new HubVisitorToggleDataSource();
  public loadingToggles = true;
  public searchParam = {
    searchTimeout: null,
    debounceTime: 500,
    isSearching: false,
    searchText: '',
    isShowSearchPlaceWithNoFilter: false,
    isSearchPlaceWithNoFilter: false,
    isShowFuzzySearch: false,
    isFuzzySearch: true,
  };
  public customDefaultPlaceCategory: CustomDefaultPlaceCategory = null;
  public isOpenRegionalAccountType = false;
  public isLoadingDMOs = false;
  public regionalAccountDMOs: Array<any>;

  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('eventAccordion') public eventAccordion: AccordionComponent;
  @ViewChild('placeAccordion') public placeAccordion: AccordionComponent;
  @ViewChild('manualAccordion') public manualAccordion: AccordionComponent;
  @ViewChild('placeLocationAccordion') public placeLocationAccordion: AccordionComponent;
  @ViewChild('customDefaultPlaceCategoryAccordion')
  public customDefaultPlaceCategoryAccordion: CustomDefaultPlaceCategoryAccordionComponent;

  constructor(
    private router: Router,
    private hubCalendarStore: HubCalendarStore,
    private formBuilder: FormBuilder,
    private hubFacebookPageFeedsStore: HubFacebookPageFeedsStore,
    private hubFacebookLocationFeedsStore: HubFacebookLocationFeedsStore,
    private pdfSettingsStore: PDFSettingsStore,
    private hubLogoStore: HubLogoStore,
    private visitorSettingsCommand: VisitorSettingsStore,
    private togglesStore: ToggleStore,
    private toggleAndDataSourceStore: ToggleAndDataSourceStore,
    private toursStore: ToursStore,
    private customBtnStore: CustomBtnStore,
    private editorChoiceStore: EditorChoiceStore,
    private customDefaultPlaceCategoryStore: CustomDefaultPlaceCategoryStore,
    private activatedRoute: ActivatedRoute,
    private customizationService: CustomizationApiService,
    private hubApiService: HubApiService,
    private imageService: ImageService,
    private KeywordService: KeywordService
  ) {
    super({ activatedRoute });
  }

  public ngOnInit() {
    let { hubName } = this.allRouteParams;
    this.hubName = hubName;
    this.searchFormGroup = this.formBuilder.group({
      searchText: [null],
    });
    this.loadingToggles = true;
    this.hubApiService.getAllSettings(this.hubName).subscribe((data: any) => {
      console.log(data);
      localStorage.setItem(localStorageKeys.allBackendSettings, JSON.stringify(data));
      localStorage.setItem(localStorageKeys.timezoneFormatterDefault, data.customSettings.timezoneFormatter);
      if (data.toggle) {
        if (this.isAllPlaceCategoriesTurnedOff) {
          data.toggle.placeCalendar = false;
        }

        this.toggleAndSource.toggle = data.toggle;
        this.toggleAndSource.dataSource = data.dataSource;
        this.togglesStore.toggleCommand.next(this.toggleAndSource.toggle);
        this.toggleAndSource.isKeepTempClosedPlaceInApproved = data.customSettings.isKeepTempClosedPlaceInApproved;
        this.toggleAndDataSourceStore.toggleAndDataSourceCommand.next(this.toggleAndSource);
        this.isOpenRegionalAccountType = data.toggle.regionalAccountType;
      }

      this.customDefaultPlaceCategory = data.customSettings.customDefaultPlaceCategory;
      console.log('sidebar customDefaultPlaceCategory', this.customDefaultPlaceCategory);

      if (data.customSettings.customEditorChoice) {
        let editorChoice = new EditorChoiceDataSource();
        editorChoice.editorChoiceForEvent =
          data.customSettings.customEditorChoice.editorChoiceForEvent || "EDITOR'S CHOICE";
        editorChoice.editorChoiceForPlace =
          data.customSettings.customEditorChoice.editorChoiceForPlace || "EDITOR'S CHOICE";
        this.editorChoiceStore.infoCommand.next(editorChoice);
      }

      this.hubPages =
        data && data.pageFeeds
          ? data.pageFeeds.filter((x) => !config.placeSocialName.any((y) => y === x.socialName))
          : [];
      this.hubLocations = data && data.locationFeeds ? data.locationFeeds : [];
      // this.facebookLocations = this.hubLocations.filter(x => config.placeSocialName.any(y => y === x.socialName));
      this.facebookLocations = this.hubLocations.filter(
        (x) => x.socialName === (this.toggleAndSource.dataSource.place || 'facebook')
      );
      this.otherLocations = this.hubLocations.filter((x) => !config.placeSocialName.any((y) => y === x.socialName));
      //this.eventFeeds = !this.toggleAndSource.toggle.eventByGeolocation ? this.hubPages : this.hubPages.concat(this.otherLocations as Array<any>);

      this.hubPages.forEach((page) => {
        page.displayTitle = page.title || '@' + page.name;
      });
      this.otherLocations.forEach((location) => {
        location.displayTitle = `${location.title} - ${
          location.socialName == 'eventful' ? 'Performers,Venues, Ticketing Websites' : location.socialName
        }`;
      });
      this.facebookLocations.forEach((location) => {
        location.displayTitle = `${location.title} - ${location.socialName}`;
      });
      this.eventFeeds = !this.toggleAndSource.toggle.eventByGeolocation
        ? this.hubPages
        : this.hubPages.concat(this.otherLocations as Array<any>);

      this.hubFacebookPageFeedsStore.pagesCommand.next(new HubFacebookFeedsCommand(this.eventFeeds));
      this.hubFacebookLocationFeedsStore.locationCommand.next(new HubFacebookFeedsCommand(this.facebookLocations));

      this.logoUrl =
        isNullOrUndefined(data.logo) || isNullOrUndefined(data.logo.isDefault) || data.logo.isDefault
          ? config.defaultLogoUrl
          : data.logo.url;
      this.logoUrl = this.imageService.imageSourceUrl(this.logoUrl);
      VisitorDataCache.logo = this.logoUrl;
      VisitorDataCache.placeCategories = data.placeCategories;
      this.hubLogoStore.logoCommand.next(data.logo);
      this.visitorSettingsCommand.settingsCommand.next(data.customSettings);

      let pdfSettings = new PDFSettingCommand();
      pdfSettings.pdf = data.pdf;
      pdfSettings.eventCalendarURL = data.eventCalendarURL;
      pdfSettings.placeCalendarURL = data.placeCalendarURL;
      pdfSettings.moreToursURL = data.moreToursURL;
      this.pdfSettingsStore.pdfCommand.next(pdfSettings);
      this.toursStore.toursCommand.next(data.tours);
      this.customBtnStore.customBtnCommand.next(data.customBtns);

      this.loadingToggles = false;

      if (this.activatedRoute.firstChild) {
        this.activatedRoute.firstChild.url.subscribe((x) => {
          this.command.isEventCalendar = x[0].path === routeConfigs.hub.eventCalendar.path;
        });
        this.command.queryParams.source = this.toggleAndSource.dataSource.place;
        this.hubCalendarStore.actionCommand.next(this.command);
      }
    });

    this.hubFacebookLocationFeedsStore.locationCommand
      .takeUntil(this.isDestroyed)
      .subscribe((hubLocations: HubFacebookFeedsCommand) => {
        this.hubLocations = hubLocations.hubPages;
        // this.facebookLocations = (this.hubLocations && this.hubLocations.length) ? this.hubLocations.filter(x => x.socialName === 'facebook') : [];
        this.facebookLocations =
          this.hubLocations && this.hubLocations.length
            ? this.hubLocations.filter(
                (x) =>
                  x.socialName ===
                  ((this.toggleAndSource.dataSource && this.toggleAndSource.dataSource.place) || 'facebook')
              )
            : [];
        // this.otherLocations = (this.hubLocations && this.hubLocations.length) ? this.hubLocations.filter(x => x.socialName !== 'facebook') : [];
        this.otherLocations =
          this.hubLocations && this.hubLocations.length
            ? this.hubLocations.filter((x) => !config.placeSocialName.any((y) => y === x.socialName))
            : [];
      });

    this.hubFacebookPageFeedsStore.pagesCommand
      .takeUntil(this.isDestroyed)
      .subscribe((hubPages: HubFacebookFeedsCommand) => {
        this.hubPages =
          hubPages.hubPages && hubPages.hubPages.length
            ? hubPages.hubPages.filter((x) => x.socialName !== 'facebook')
            : [];
      });

    this.hubLogoStore.logoCommand.takeUntil(this.isDestroyed).subscribe((logo: LogoCommand) => {
      this.logoUrl =
        isNullOrUndefined(logo) || isNullOrUndefined(logo.isDefault) || logo.isDefault
          ? config.defaultLogoUrl
          : logo.url;
      this.logoUrl = this.imageService.imageSourceUrl(this.logoUrl);
    });

    this.customDefaultPlaceCategoryStore.CustomDefaultPlaceCategoryCommand.takeUntil(this.isDestroyed).subscribe(
      (category: CustomDefaultPlaceCategory) => {
        if (!isEmptyObject(category)) {
          this.customDefaultPlaceCategory = category;
        }
      }
    );
  }

  public get isShowThingsToDo() {
    return (
      !this.loadingToggles &&
      (this.toggleAndSource.toggle.placeCategory.activity ||
        this.toggleAndSource.toggle.placeCategory.art ||
        this.toggleAndSource.toggle.placeCategory.outdoor ||
        this.toggleAndSource.toggle.placeCategory.entertainment)
    );
  }

  public get isEventEnabled() {
    return this.toggleAndSource.toggle.manualEvents || this.toggleAndSource.toggle.eventByGeolocation;
  }

  public close() {
    this.onClose.emit();
  }

  public showFacebookEvents() {
    this.command.isEventCalendar = true;
    this.command.queryParams.category = 'All';
    this.command.queryParams.feedId = null;
    this.command.queryParams.isManuallyCreated = null;
    this.command.queryParams.isHubCreated = null;
    this.hubCalendarStore.actionCommand.next(this.command);

    this.router.navigateByUrl(
      getRouteUrl(routeConfigs.hub.eventCalendar, {
        hubName: this.hubName,
      })
    );
    this.displayingOn = DisplayingOn.event;
  }

  public showManualEvents(eventsType: any) {
    this.command.isEventCalendar = true;
    this.command.queryParams.feedId = null;
    this.command.queryParams.isManuallyCreated = true;
    this.command.queryParams.isHubCreated = null;
    if (eventsType !== 'All') {
      this.command.queryParams.isHubCreated = eventsType == 'Hub';
    }
    this.command.queryParams.isApproved = false;
    this.hubCalendarStore.actionCommand.next(this.command);
    this.router.navigateByUrl(
      getRouteUrl(routeConfigs.hub.eventCalendar, {
        hubName: this.hubName,
      })
    );
    this.displayingOn = DisplayingOn.event;
  }

  public showManualPlaces(eventsType: any) {
    this.command.isEventCalendar = false;
    this.command.queryParams.feedId = null;
    this.command.queryParams.isManuallyCreated = true;
    this.command.queryParams.isHubCreated = null;
    this.command.queryParams.isApproved = false;
    if (eventsType !== 'All') {
      this.command.queryParams.isHubCreated = eventsType == 'Hub';
    }
    this.hubCalendarStore.actionCommand.next(this.command);
    this.router.navigateByUrl(
      getRouteUrl(routeConfigs.hub.placeCalendar, {
        hubName: this.hubName,
      })
    );
    this.displayingOn = DisplayingOn.place;
  }

  public showPlacesByFeed(feedId) {
    this.router.navigateByUrl(
      getRouteUrl(routeConfigs.hub.placeCalendar, {
        hubName: this.hubName,
      })
    );
    this.command.isEventCalendar = false;
    this.command.queryParams.feedId = feedId;
    this.command.queryParams.category = 'all';
    this.command.queryParams.isManuallyCreated = false;
    this.command.queryParams.isHubCreated = false;
    this.command.queryParams.search = '';
    this.hubCalendarStore.actionCommand.next(this.command);
    this.searchParam.searchText = '';
    this.displayingOn = DisplayingOn.place;
  }

  public showPageEvents(feedId) {
    this.command.isEventCalendar = true;
    this.command.queryParams.feedId = feedId;
    this.command.queryParams.category = 'All';
    this.command.queryParams.isManuallyCreated = false;
    this.command.queryParams.isHubCreated = null;
    this.command.queryParams.from = this.isFilterDateEnabled ? this.command.queryParams.from : null;
    this.command.queryParams.to = this.isFilterDateEnabled ? this.command.queryParams.to : null;
    this.hubCalendarStore.actionCommand.next(this.command);

    this.router.navigateByUrl(
      getRouteUrl(routeConfigs.hub.eventCalendar, {
        hubName: this.hubName,
      })
    );
    this.displayingOn = DisplayingOn.event;
  }

  public showEventsByDMO(dmo) {
    this.command.isEventCalendar = true;
    this.command.queryParams.category = 'All';
    this.command.queryParams.isHubCreated = null;
    this.command.queryParams.isApproved = this.eventStatusSelection === 'approved';
    this.command.queryParams.from = this.isFilterDateEnabled ? this.command.queryParams.from : null;
    this.command.queryParams.to = this.isFilterDateEnabled ? this.command.queryParams.to : null;
    this.command.queryParams.dmo = dmo;
    this.hubCalendarStore.actionCommand.next(this.command);

    this.router.navigateByUrl(
      getRouteUrl(routeConfigs.hub.eventCalendar, {
        hubName: this.hubName,
      })
    );
    this.displayingOn = DisplayingOn.event;
  }

  public feedIsSelected(feedId): boolean {
    if (this.command.queryParams.feedId == null && feedId.toLowerCase() === 'all') {
      return true;
    } else {
      return this.command.queryParams.feedId === feedId;
    }
  }

  public manualEventsIsSelected(eventType): boolean {
    if (!this.command.isEventCalendar) {
      return false;
    }
    if (this.command.queryParams.isHubCreated == null && eventType == 'All') {
      return true;
    } else {
      let isHubCreated = eventType == 'Hub';
      return this.command.queryParams.isHubCreated == isHubCreated;
    }
  }

  public manualPlacesIsSelected(eventType): boolean {
    if (this.command.isEventCalendar) {
      return false;
    }
    if (this.command.queryParams.isHubCreated == null && eventType == 'All') {
      return true;
    } else {
      let isHubCreated = eventType == 'Hub';
      return this.command.queryParams.isHubCreated == isHubCreated;
    }
  }

  public loadLocationFeeds() {
    if (!this.hubLocations || !this.hubLocations.length) {
      this.isLoadingFeeds = true;
      this.hubApiService.getLocationFeeds(this.hubName).subscribe((data) => {
        this.hubLocations = data;
        // this.facebookLocations = data.filter(x => config.placeSocialName.any(y => y === x.socialName));
        this.facebookLocations = this.hubLocations.filter(
          (x) => x.socialName === (this.toggleAndSource.dataSource.place || 'google') && x.title
        );
        this.otherLocations = data.filter((x) => !config.placeSocialName.any((y) => y === x.socialName));
        this.eventFeeds = !this.toggleAndSource.toggle.eventByGeolocation
          ? this.hubPages
          : this.hubPages.concat(this.otherLocations as Array<any>);
        this.isLoadingFeeds = false;
        this.hubFacebookLocationFeedsStore.locationCommand.next(new HubFacebookFeedsCommand(this.hubLocations));
      });
    } else {
      // this.facebookLocations = this.hubLocations.filter(x => config.placeSocialName.any(y => y === x.socialName));
      this.facebookLocations = this.hubLocations.filter(
        (x) => x.socialName === (this.toggleAndSource.dataSource.place || 'google') && x.title
      );
      this.otherLocations = this.hubLocations.filter((x) => !config.placeSocialName.any((y) => y === x.socialName));
      this.eventFeeds = !this.toggleAndSource.toggle.eventByGeolocation
        ? this.hubPages
        : this.hubPages.concat(this.otherLocations as Array<any>);
    }
  }

  public loadRegionalAccountDMOs() {
    if (!this.regionalAccountDMOs || !this.regionalAccountDMOs.length) {
      this.isLoadingDMOs = true;
      this.hubApiService.getRegionalAccountDMOs(this.hubName).subscribe((data) => {
        this.regionalAccountDMOs = data;
        this.isLoadingDMOs = false;
      });
    }
  }

  public dmoIsSelected(dmo): boolean {
    if (this.command.queryParams.dmo == null && dmo.toLowerCase() === 'all') {
      return true;
    } else {
      return this.command.queryParams.dmo === dmo;
    }
  }

  public placeCategoryIsSelected(category): boolean {
    return this.command.queryParams.category == category && !this.command.isEventCalendar;
  }

  public expandPlace($event) {
    if (!this.toggleAndSource.toggle.placeCalendar) {
      $event.stopPropagation();
      return;
    }
    this.showPlace($event);
  }

  public selectCustomDefaultPlaceCategory($event: PlaceType) {
    console.log($event);

    this.router.navigateByUrl(
      getRouteUrl(routeConfigs.hub.placeCalendar, {
        hubName: this.hubName,
      })
    );
    this.setToApprovedIfIsOnSimilarPlaces();
    this.command.isEventCalendar = false;
    this.command.queryParams.feedId = null;
    this.command.queryParams.category = $event.title;
    this.command.queryParams.categoryList = $event.categoryList;
    this.command.queryParams.isManuallyCreated = false;
    this.command.queryParams.isHubCreated = null;
    this.command.queryParams.search = '';
    this.hubCalendarStore.actionCommand.next(this.command);
    this.searchParam.searchText = '';
    this.command.queryParams.source = this.toggleAndSource.dataSource.place;
    this.displayingOn = DisplayingOn.place;
  }

  public clearSearchText(type: string) {
    this.searchParam.searchText = '';
    this.router.navigateByUrl(
      getRouteUrl(type === 'place' ? routeConfigs.hub.placeCalendar : routeConfigs.hub.eventCalendar, {
        hubName: this.hubName,
      })
    );
    this.command.isEventCalendar = type === 'event';
    this.command.queryParams.feedId = null;
    this.command.queryParams.category = 'All';
    this.command.queryParams.search = undefined;
    this.command.queryParams.isManuallyCreated = undefined;
    this.command.queryParams.noFilter = this.searchParam.isSearchPlaceWithNoFilter;
    //this.command.queryParams.isApproved = true;
    this.hubCalendarStore.actionCommand.next(this.command);
    this.KeywordService.updateKeyword(this.searchParam.searchText);
  }

  public searchFocus() {
    this.searchParam.isShowSearchPlaceWithNoFilter = true;
    this.searchParam.isShowFuzzySearch = true;
  }

  public search() {
    this.searchParam.isSearching = true;
    this.router.navigateByUrl(
      getRouteUrl(routeConfigs.hub.placeCalendar, {
        hubName: this.hubName,
      })
    );
    this.command.isEventCalendar = false;
    this.command.queryParams.feedId = null;
    this.command.queryParams.category = 'All';
    this.command.queryParams.search = this.searchParam.searchText;
    // search all places existing in the database, ignore whether it is blocked, blacklisted or category not in allowed list
    this.command.queryParams.noFilter = this.searchParam.isSearchPlaceWithNoFilter;
    this.command.queryParams.useFuzzyQuery = this.searchParam.isFuzzySearch;
    this.command.queryParams.isManuallyCreated = undefined;
    //this.command.queryParams.isApproved = undefined;
    this.hubCalendarStore.actionCommand.next(this.command);
    this.KeywordService.updateKeyword(this.searchParam.searchText);
    
    setTimeout(() => {
      this.searchParam.isSearching = false;
    }, 3000);
  }

  public searchEvents() {
    if (this.eventStatusSelection === 'similar') {
      this.eventStatusSelection = 'approved';
      this.command.queryParams.isApproved = true;
    }
    this.searchParam.isSearching = true;
    this.router.navigateByUrl(
      getRouteUrl(routeConfigs.hub.eventCalendar, {
        hubName: this.hubName,
      })
    );
    this.command.isEventCalendar = true;
    this.command.queryParams.feedId = null;
    this.command.queryParams.category = 'All';
    this.command.queryParams.search = this.searchParam.searchText;
    this.command.queryParams.isManuallyCreated = undefined;

    if (!this.isOpenRegionalAccountType) {
      this.command.queryParams.dmo = null;
    }

    this.hubCalendarStore.actionCommand.next(this.command);

    setTimeout(() => {
      this.searchParam.isSearching = false;
    }, 3000);
  }

  public searchPlacesWithNoFilterChange() {
    if (this.searchParam.searchText) {
      this.search();
    }
  }

  public fuzzySearchPlaces() {
    if (this.searchParam.searchText) {
      this.search();
    }
  }

  public showEditView() {
    this.router.navigateByUrl(
      getRouteUrl(routeConfigs.hub.editAccount, {
        hubName: this.hubName,
      })
    );
    this.displayingOn = DisplayingOn.contentManagement;
    this.closeContentAccordions();
  }

  public showContentManagementView() {
    this.router.navigateByUrl(
      getRouteUrl(routeConfigs.hub.contentManagement, {
        hubName: this.hubName,
      })
    );
    this.displayingOn = DisplayingOn.contentManagement;
    this.closeContentAccordions();
  }

  public showCustomizeStyle() {
    this.router.navigateByUrl(
      getRouteUrl(routeConfigs.hub.customization, {
        hubName: this.hubName,
      })
    );
    this.displayingOn = DisplayingOn.design;
    this.closeContentAccordions();
  }

  public showMarketing() {
    this.router.navigateByUrl(
      getRouteUrl(routeConfigs.hub.marketing, {
        hubName: this.hubName,
      })
    );
    this.displayingOn = DisplayingOn.marketing;
    this.closeContentAccordions();
  }

  public showUploadEvents() {
    this.router.navigateByUrl(
      getRouteUrl(routeConfigs.hub.uploadEvents, {
        hubName: this.hubName,
      })
    );
    this.displayingOn = DisplayingOn.uploadEvents;
    this.closeContentAccordions();
  }

  public async showTours() {
    await this.router.navigateByUrl(
      getRouteUrl(routeConfigs.hub.tours, {
        hubName: this.hubName,
      })
    );
    this.displayingOn = DisplayingOn.tripPlanner;
  }

  //
  // public async showGooglePlace() {
  //     await this.router.navigateByUrl(getRouteUrl(routeConfigs.hub.googlePlace, {
  //         hubName: this.hubName
  //     }));
  // }

  public showPlace(value: any) {
    if (!value.target.id) {
      return;
    }

    value.target.id = value.target.id === 'All-places' ? 'All' : value.target.id;

    this.router.navigateByUrl(
      getRouteUrl(routeConfigs.hub.placeCalendar, {
        hubName: this.hubName,
      })
    );
    this.command.isEventCalendar = false;
    this.command.queryParams.feedId = null;
    this.command.queryParams.category = value.target.id;
    this.command.queryParams.categoryList = null;
    this.setToApprovedIfIsOnSimilarPlaces();
    this.command.queryParams.isManuallyCreated = false;
    this.command.queryParams.isHubCreated = null;
    this.command.queryParams.search = '';
    this.hubCalendarStore.actionCommand.next(this.command);
    this.searchParam.searchText = '';
    this.command.queryParams.source = this.toggleAndSource.dataSource.place;
    this.displayingOn = DisplayingOn.place;
  }

  public filterEvents() {
    console.log('isFilterDateEnabled', this.isFilterDateEnabled);
    console.log('eventStatusSelection', this.eventStatusSelection);

    if (this.isFilterDateEnabled && this.eventStatusSelection === 'similar') {
      this.eventStatusSelection = 'approved';
    }
    // see similarEvents()
    if (this.eventStatusSelection === 'similar') return;

    this.command.queryParams.isApproved = this.eventStatusSelection === 'approved';

    let routeParams = { hubName: this.hubName };
    let eventCalendarUrl = getRouteUrl(routeConfigs.hub.eventCalendar, routeParams);

    if (!this.router.isActive(eventCalendarUrl, false)) {
      this.router.navigateByUrl(eventCalendarUrl);
    }

    let command = new HubCalendarActionCommand();
    command.queryParams.from = this.isFilterDateEnabled ? this.command.queryParams.from : null;
    command.queryParams.to = this.isFilterDateEnabled ? this.command.queryParams.to : null;
    command.queryParams.isApproved = this.command.queryParams.isApproved;
    command.queryParams.dmo = this.command.queryParams.dmo;
    command.isEventCalendar = true;
    command.queryParams.isManuallyCreated = undefined;
    command.queryParams.isHubCreated = undefined;
    command.queryParams.feedId = this.command.queryParams.feedId;
    this.searchParam.searchText = null;

    if (command.queryParams.from) {
      command.queryParams.from.setHours(0);
      command.queryParams.from.setMinutes(0);
      command.queryParams.from.setSeconds(0);
    }

    if (command.queryParams.to) {
      command.queryParams.to = new Date(EventTimeService.addHours(command.queryParams.to, 24));
      command.queryParams.to.setHours(0);
      command.queryParams.to.setMinutes(0);
      command.queryParams.to.setSeconds(0);
    }

    this.hubCalendarStore.actionCommand.next(command);

    this.displayingOn = DisplayingOn.event;
  }

  public similarEvents() {
    this.eventStatusSelection = 'similar';
    this.isFilterDateEnabled = false;
    this.command.queryParams.search = undefined;

    let routeParams = { hubName: this.hubName, type: 'normal' };
    let similarEventCalendarUrl = getRouteUrl(routeConfigs.hub.similarEventCalendar, routeParams);

    // if (!this.router.isActive(similarEventCalendarUrl, false))
    this.router.navigateByUrl(similarEventCalendarUrl);
  }

  public similarPlaces() {
    this.placeLocationAccordion && this.placeLocationAccordion.isFiltering && this.placeLocationAccordion.clearFilter();
    // this.placeSourceAccordion && this.placeSourceAccordion.isFiltering && this.placeSourceAccordion.clearFilter();
    this.customDefaultPlaceCategoryAccordion && this.customDefaultPlaceCategoryAccordion.clearFilter();
    this.command.queryParams.search = undefined;
    // this.command.queryParams.isNewlyPulled = undefined;
    this.command.queryParams.category = undefined;
    this.command.queryParams.categoryList = undefined;
    this.command.queryParams.isManuallyCreated = undefined;
    this.command.queryParams.feedId = undefined;
    this.command.queryParams.isApproved = undefined;
    this.searchParam.searchText = '';

    let routeParams = { hubName: this.hubName };
    let similarPlaceCalendarUrl = getRouteUrl(routeConfigs.hub.similarPlaceCalendar, routeParams);

    this.router.navigateByUrl(similarPlaceCalendarUrl);
  }

  public filterPlaces(isApprovedAction: boolean) {
    let routeParams = { hubName: this.hubName };
    let placeCalendarUrl = getRouteUrl(routeConfigs.hub.placeCalendar, routeParams);

    if (!this.router.isActive(placeCalendarUrl, false)) {
      this.router.navigateByUrl(placeCalendarUrl);
    }

    let command = new HubCalendarActionCommand();
    command.queryParams.isApproved = this.command.queryParams.isApproved;
    command.queryParams.category = this.command.queryParams.category;
    command.isEventCalendar = false;
    command.queryParams.isManuallyCreated = undefined;
    command.queryParams.isHubCreated = undefined;
    command.queryParams.source = this.toggleAndSource.dataSource.place;
    //if (isApprovedAction) {
    command.queryParams.feedId = this.command.queryParams.feedId;
    command.queryParams.search = null;
    this.searchParam.searchText = null;
    //}
    if (command.queryParams.from) {
      let fromDate = new Date(command.queryParams.from);
      fromDate.setHours(0);
      fromDate.setMinutes(0);
      fromDate.setSeconds(0);
      command.queryParams.from = fromDate;
    }
    if (command.queryParams.to) {
      let toDate = new Date(command.queryParams.to);
      toDate.setHours(0);
      toDate.setMinutes(0);
      toDate.setSeconds(0);
      command.queryParams.to = toDate;
    }

    // show all places when selecting unapproved
    this.searchParam.isSearchPlaceWithNoFilter = !this.command.queryParams.isApproved;
    command.queryParams.noFilter = !this.command.queryParams.isApproved;

    this.hubCalendarStore.actionCommand.next(command);

    this.displayingOn = DisplayingOn.place;
  }

  private closeContentAccordions() {
    this.eventAccordion.close();
    this.placeAccordion.close();
    this.manualAccordion.close();
  }

  private get isAllPlaceCategoriesTurnedOff() {
    return PlaceService.isAllCategoriesTurnedOff(this.toggleAndSource.toggle.placeCategory);
  }

  public setToApprovedIfIsOnSimilarPlaces() {
    // this.command.queryParams.isApproved is null or undefined means now showing similar places, so remove the radio button selection
    this.command.queryParams.isApproved = isNullOrUndefined(this.command.queryParams.isApproved)
      ? true
      : this.command.queryParams.isApproved;
  }
}

export enum DisplayingOn {
  event = 0,
  place = 1,
  manualEntry = 2,
  tripPlanner = 3,
  contentManagement = 4,
  design = 5,
  marketing = 6,
  uploadEvents = 7,
  googlePlace = 8,
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/side.bar/hub.side.bar.component.ts